import { pipe, Either, Task } from "fp";

import { type, creator, reducer, effects } from "~/Action";
import * as Data from "~/Data";
import * as Driver from "~/Driver";
import * as WorkCode from "~/WorkCode";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Drivers requested" as const),
    reducer(
      ({ state }) =>
        (state.drivers.store = Data.Store.requested(state.drivers.store))
    ),
    effects(({ dispatch, state: { context, companies } }) =>
      pipe(
        Driver.Request.Get.request(companies.current)(context),
        Task.map((drivers) => dispatch(Received.create(drivers)))
      )()
    )
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Drivers received" as const),
    creator((drivers?: Either.ErrorOr<Data.Cache.Cache<Driver.Driver>>) => ({
      drivers,
    })),
    reducer(
      ({ state, action: { drivers } }) =>
        (state.drivers.store = Data.Store.received(drivers)(
          state.drivers.store
        ) as typeof state.drivers.store)
    ),
    effects(({ dispatch }) => dispatch(WorkCode.Action.Requested.create()))
  );
}

export namespace Filtered {
  export namespace Requested {
    export const { TYPE, create, reduce } = pipe(
      type("Filtered drivers requested" as const),
      reducer(
        ({ state }) =>
          (state.drivers.filteredStore = Data.Store.requested(
            state.drivers.filteredStore
          ))
      ),
      effects(({ dispatch, state: { context, companies, drivers } }) =>
        pipe(
          Driver.Request.Get.request(companies.current, {
            reportingLocationIDs: drivers.filter,
            branchIDs: drivers.branchFilter,
          })(context),
          Task.map((drivers) => dispatch(Received.create(drivers)))
        )()
      )
    );
  }

  export namespace Received {
    export const { TYPE, create, reduce } = pipe(
      type("Filtered drivers received" as const),
      creator((drivers?: Either.ErrorOr<Data.Cache.Cache<Driver.Driver>>) => ({
        drivers,
      })),
      reducer(
        ({ state, action: { drivers } }) =>
          (state.drivers.filteredStore = Data.Store.received(drivers)(
            state.drivers.filteredStore
          ) as typeof state.drivers.filteredStore)
      ),
      effects(({ dispatch }) => dispatch(WorkCode.Action.Requested.create()))
    );
  }
}
